import Style from "./AlbumImageContainer.module.scss";
import { useEffect, useRef, useState } from "react";
import { useDrag, useDrop, DragPreviewImage } from "react-dnd";
import useGalleryImage from "../../../../Logic/useGalleryImage";
import useGallery from "../../../../Logic/useGallery";
import Icons from "../../../../components/Layouts/Icons";
import { ProgressBar } from "react-bootstrap";
import placeholder1 from "../../../../assets/placeholder-image.svg";
import { handleremoveFailedItem } from "../../../../store/slices/gallerySlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CommonModal from "../../../Modals/commonModal";
import useAlbum from "../../../../Logic/useAlbum";
import { ref } from "yup";

const AlbumImageContainer = ({
  image,
  i,
  moveListItem,
  handleOpenImageFullView,
  frame,
  frameData,
  albumData,
  handleDeleteAction,
  type,
  handleDeleteAlbumImages,
}) => {
  const someRef = useRef(null);

  const [isActive, setActive] = useState("false");
  const dispatch = useDispatch();

  const handleToggle = () => {
    setActive(!isActive);
  };

  const { toBeDragged, setToBeDragged, handleMouseDown, handleMouseUp } =
    useGalleryImage();
  const {
    addImageHandler,
    handleClickFavorite,
    handleDeleteImages,
    removeFromArchive,
  } = useGallery();

  const { addImageHandlerForAlbum } = useAlbum();

  const {
    sections,
    currentTab,
    activeUploadIndex,
    isSingleImageUpload,
    activeUploadPercent,
    allImageStatus,
    faileditems,
    selectedAlbumImages,
    selectedAlbum,
  } = useSelector((state) => state.gallery);
  const [onMouseHover, setOnMouseHover] = useState(false);
  const [onLoadState, setOnLoadState] = useState(false);
  const [deletePhotoModal, setDeletePhotoModal] = useState(false);

  const [isShake, setIsShake] = useState(true);

  const [{ isDragging }, dragRef] = useDrag({
    type: "item",
    item: { i },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const handleRemove = (e) => {
    setOnLoadState(true);
  };

  const clickHandler = (i) => {
    if (sections[currentTab]?.currentActions?.preSlectionAlbumItem) {
      addImageHandlerForAlbum(image?.id);
    } else {
      handleOpenImageFullView(i);
    }
  };
  const [spec, dropRef] = useDrop({
    accept: "item",
    spec: { index: i },
    drop: (item) => {
      moveListItem(
        item.i,
        i,
        sections[currentTab]?.list[selectedAlbum]?.images
      );
    },
  });

  useEffect(() => {
    if (!isDragging) {
      setToBeDragged(false);
    }
  }, [isDragging]);

  const handleMouseEnter = () => {
    if (!sections[currentTab]?.currentActions?.preSlectionAlbumItem) {
      if (!sections[currentTab]?.currentActions?.rearrange) {
        setOnMouseHover(true);
      }
    }
  };

  const handleMouseLeave = () => {
    if (!sections[currentTab]?.currentActions?.preSlectionAlbumItem) {
      setOnMouseHover(false);
    }
  };

  return (
    <div
      className={Style.drop_container}
      ref={sections[currentTab]?.currentActions?.rearrange ? dropRef : someRef}
      style={{
        opacity: isDragging ? 0 : 1,
        position: "relative",
      }}
    >
      <div
        className={`${Style.gallery_image_cont} ${sections[currentTab]?.currentActions?.rearrange &&
          Style.gallery_image_cont_edit
          } ${image.favourite == 1 ? `${Style.favorite_active} favorite-active` : ""
          } ${allImageStatus === "loading" ? "data-loading" : ""}`}
      >
        <figure
          className={`${Style.gallery_image_wrap} ${frameData?.image && frameData?.name == "None"
            ? Style.frameFit_none
            : Style.frameFit
            } ${faileditems?.includes(i) ? Style.image_error : ""} ${onMouseHover ? Style.onHover_figure : ""
            } ${!onLoadState ? "img-loading" : "img-loaded"}
            ${isShake ? Style.shake_active : ""}
            `}
          style={{
            borderImageSource: `url(${frameData?.name == "None" ? "" : frameData?.image
              })`,
          }}
          onMouseDown={() => setIsShake(false)}
          onMouseUp={() => setIsShake(true)}
        >
          {sections[currentTab]?.selectedAlbumImages?.includes(image?.id) &&
            sections[currentTab]?.currentActions?.preSlectionAlbumItem &&
            !sections[currentTab]?.currentActions?.rearrange ? (
            <figure className={Style.gallery_select_tick}>
              <Icons icon={"icon-tick"} size={15} />
            </figure>
          ) : sections[currentTab]?.currentActions?.preselect ||
            sections[currentTab]?.currentActions?.preSlectionAlbumItem ? (
            <div className="selection" />
          ) : (
            ""
          )}
          <img
            style={{
              transform:
                albumData?.album?.crop_value > 0 &&
                ` scale(${albumData?.album?.crop_value})`,
            }}
            ref={
              sections[currentTab]?.currentActions?.rearrange
                ? dragRef
                : someRef
            }
            className={` ${image?.src?.encoded ? Style.placeholder_image_active : ""
              } ${currentTab == "all" && Style.galleryMode}`}
            onClick={() => clickHandler(i)}
            src={image?.src?.encoded}
            alt="Loading"
            onMouseEnter={() => handleMouseEnter()}
            onMouseLeave={() => handleMouseLeave()}
            onMouseDown={() =>
              sections[currentTab]?.currentActions?.rearrange &&
              handleMouseDown()
            }
            onMouseUp={handleMouseUp}
            onLoad={(e) => handleRemove(e)}
          />

          {image?.src?.thumbnail1 ? (
            <div
              className={`${Style.gallery_image_tray} image_tray`}
              style={{ display: toBeDragged ? "none" : "flex" }}
            >
              <div className={Style.tray_details}>
                <div className={Style.gallery_image_tray_author}>
                  {image?.user?.username}{" "}
                </div>
                <div
                  className={`${Style.gallery_image_tray_post_date} post-date-wrap`}
                >
                  {image?.metadata?.file_date_time ? (
                    <>
                      <span className="post-date-label">Captured on:</span>{" "}
                      <span className="post-date">
                        {moment(
                          image?.metadata?.file_date_time).format("DD MMM YYYY hh:mm A")}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </figure>
      </div>
      <div></div>
    </div>
  );
};

export default AlbumImageContainer;
